import { createContext } from 'react'

import { HeroBannerProps } from '.'

export type HeroBannerContextType = HeroBannerProps

export const HeroBannerContext = createContext<HeroBannerContextType>(
  {} as HeroBannerContextType,
)
